import { render, staticRenderFns } from "./CompanyRegistration.vue?vue&type=template&id=5eb50344&"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports